import { ObjectShape } from "yup";

import {
  currentDateAtMidnightISO,
  TimeZoneEnum,
  yupLocalized,
} from "@ryde/shared";

import { bulkCreateBookingsValidationSchema } from "../bulk-bookings-components";

export const addNewBulkBookingsValidationSchema = {
  passengers: yupLocalized.array().required(),
  date: yupLocalized.date().required(),
  ...bulkCreateBookingsValidationSchema,
};

export const getAddNewBulkBookingsValidationSchemaAccordingToPermission = (
  hasPermissionCreateInThePast: boolean,
  timezone: TimeZoneEnum,
): ObjectShape => {
  if (!hasPermissionCreateInThePast) {
    return {
      ...addNewBulkBookingsValidationSchema,
      date: yupLocalized
        .date()
        .min(currentDateAtMidnightISO(timezone))
        .required(),
    };
  }

  return addNewBulkBookingsValidationSchema;
};
